export const themeTodo = {
  primaryColor: 'grey',
  secondaryColor: '#d3d3d3',
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 25px 50px 0 rgba(0, 0, 0, 0.1)',
}
